<template>
    <div v-if="showComFoldCause" class="com-fold">
        <div class="header">
            <img
                :src="back"
                class="back"
                @click="closeComFoldPage"
            >
            <div class="tit">为什么被折叠</div>
        </div>
        <div class="title">什么是「折叠」</div>
        <div class="con">
            「折叠」是我们为了维护良好的评价区讨论氛围而设计的机制。我们欢迎大家自由地表达自
            己的态度，心平气和地发表言论，鼓励创造更有价值的内容。如果评价内容对于游戏玩家没
            有帮助，就会进入折叠区，在列表最下方集中展示。
        </div>
        <div class="title">哪些类型的评价会被折叠</div>
        <div class="con">
            1. 多位用户点踩的评论。<br>
            2. 非良性或无意义评论。例如：纯语气词、标点、数字等完全无意义、高度重复内容。
        </div>
    </div>
</template>

<script>
    import back from 'public/assets/imgs/navigate-back-black.png';
    export default {
        props: {
            showComFoldCause: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                back: back
            }
        },
        methods: {
            closeComFoldPage() {
                this.$emit('closeComFoldPage');
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .com-fold {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;
        height: 100%;
        background-color: #fff;
        padding: 0 px2rem(51);
        color: #1F1F1F;
        font-size: px2rem(57);
        .header {
            padding: px2rem(39) 0;
            display: flex;
            font-weight: 600;
            align-items: center;
            .back {
                width: px2rem(56);
                height: px2rem(66);
                margin: 0 px2rem(344) 0 px2rem(10);
            }
        }
        .title {
            font-family: PingFangSC-Semibold;
            line-height: px2rem(57);
            font-weight: 600;
            margin: px2rem(54) 0 px2rem(74);
        }
        .con {
            font-family: PingFangSC-Regular;
            line-height: px2rem(57);
            line-height: px2rem(90);
            font-weight: 400;
            padding-bottom: px2rem(52);
        }    
    }
</style>